import { Moment } from "moment";
import { Flex, HStack, Icon, Text, Link } from "@chakra-ui/react";
import { BsCalendarFill, BsClockFill } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";
import {JobEstimationDetail} from "../../modals/JobEstimationDetail";

require("./Summary.css");

interface SummaryProps {
  bookingDate: Moment | null;
  bookingSlot: any;
  estimateDetails: JobEstimationDetail;
}

const Summary = (props: SummaryProps) => {
  return (
    <Flex p={4} boxShadow={"base"} borderRadius={4} flexFlow={"column"}>
      <Text
        fontSize="xl"
        fontWeight={"bold"}
        color={"blue.700"}
        textTransform={"uppercase"}
        mb={4}
      >
        Booking Confirmation
      </Text>
      <HStack mb={4}>
        <Icon as={BsCalendarFill} w={10} h={10} mr={2} color={"blue.500"} />
        <Flex flexFlow={"column"} textAlign={"left"}>
          <Text fontSize={"x-small"}>Date</Text>
          <Text>{props.bookingDate?.format("dddd, DD/MM/YYYY")}</Text>
        </Flex>
      </HStack>
      <HStack mb={4}>
        <Icon as={BsClockFill} w={10} h={10} mr={2} color={"blue.500"} />
        <Flex flexFlow={"column"} textAlign={"left"}>
          <Text fontSize={"x-small"}>Time</Text>
          <Text>{props.bookingSlot?.time}</Text>
        </Flex>
      </HStack>
      <HStack mb={4}>
        <Icon as={MdLocationOn} w={10} h={10} mr={2} color={"blue.500"} />
        <Flex flexFlow={"column"} textAlign={"left"}>
          <Text fontSize={"x-small"}>Location</Text>
          <Link
            href={
              "https://www.google.com/maps/place/Flow+Autobody/@-27.41808,152.9913919,17z/data=!4m13!1m7!3m6!1s0x6b9157748dcf3b43:0x975c92977c38c430!2s256+S+Pine+Rd,+Enoggera+QLD+4051!3b1!8m2!3d-27.41808!4d152.9935806!3m4!1s0x6b915774ed913c9b:0x787592295017734!8m2!3d-27.41808!4d152.9935806"
            }
            isExternal
          >
            256 S Pine Rd, Enoggera QLD 4051
          </Link>
        </Flex>
      </HStack>
    </Flex>
  );
};

export default Summary;
